import { isCamaraActiva } from "../../utils/camaraStatus.js";
import React, { useState, useEffect } from 'react';
import { Chip } from "../model/chips";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { notifySlotQuotaError } from "../../utils/slotQuota.js";
import { updateStockChip, createStockChip, assignStockChipCamara } from '../api/chipsEndpoints.api';
import { getAllCustomers } from '../../customerManager/api/CustomerManager.api';
import { getCustomerCamaras, updateCamaraById, getCustomerCamarasWithoutStockChip } from '../../camaraManager/api/camaraManager.api';

interface SaveAndEditChipModalProps {
  isOpen: boolean;
  onClose: () => void;
  chipData?: Chip;
}

const SaveAndEditChipModal: React.FC<SaveAndEditChipModalProps> = ({ isOpen, onClose, chipData }) => {
  
  const isAssigned = Boolean(chipData?.customerId && chipData?.camIdentifier);

  const [chip, setChip] = useState<Chip>({
    id: '',
    customerId: '',
    camIdentifier: '',
    brand: '',
    lisualSerialNumber: '',
    associatedName: '',
    serialNumber: '',
    phoneNumber: '',
    slotCamId: '',
    assignedDate: '',
    createdAt: '',
    status: '',
    imsi: '',
    plan: '',
    tecnologia: '',
    consumo: '',
    etiquetas: '',
    notasDeLinea: ''
  });

  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState<any[]>([]);
  const [camsByCustomer, setCamsByCustomer] = useState<any[]>([]);
  const [loadingCustomers, setLoadingCustomers] = useState(false);
  const [loadingCams, setLoadingCams] = useState(false);


  // cargar clientes al abrir modal
    useEffect(() => {
    if (isOpen) {
      setLoadingCustomers(true);
      getAllCustomers()
        .then((res) => {
          const sorted = [...res].sort((a, b) => {
            const nameA = (a.name || a.customerId || "").toLowerCase();
            const nameB = (b.name || b.customerId || "").toLowerCase();
            return nameA.localeCompare(nameB);
          });
          setCustomers(sorted);
        })
        .catch((err) => console.error("Error al cargar clientes:", err))
        .finally(() => setLoadingCustomers(false));
    }
  }, [isOpen]);


  // cargar cámaras cuando cambia el cliente
   useEffect(() => {
    if (chip.customerId) {
      setLoadingCams(true);
      getCustomerCamarasWithoutStockChip(chip.customerId)
        .then((res) => {
          // mapeo: id -> slotCamId, y se excluyen las cámaras con obra terminada
          const mapped = res
            .filter((c: any) => isCamaraActiva(c))
            .map((c: any) => ({
              ...c,
              slotCamId: c.id,
            }));


          const sorted = [...mapped].sort((a, b) =>
            (a.identifier || "").localeCompare(b.identifier || "")
          );
  
          setCamsByCustomer(sorted);
        })
        .catch((err) => console.error("Error al cargar cámaras del cliente:", err))
        .finally(() => setLoadingCams(false));
    } else {
      setCamsByCustomer([]);
    }
  }, [chip.customerId]);


  // abre con la carga o sin nada para crear
useEffect(() => {
  if (chipData){
    setChip(chipData);
  } else {
    setChip({
      id: '',
      customerId: '',
      camIdentifier: '',
      brand: '',
      lisualSerialNumber: '',
      associatedName: '',
      serialNumber: '',
      phoneNumber: '',
      slotCamId: '',
      assignedDate: '',
      createdAt: '',
      status: ''
    });
  }
}, [chipData]);


    //maneja los cambios
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    let inputValue = value;
    console.log("VALUES",camsByCustomer)
    if (name === 'phoneNumber') {
    inputValue = value.replace(/\D/g, ''); 
    }
    if (name === "camIdentifier") {
      console.log("HOLA");
        const selectedCam = camsByCustomer.find(c => c.identifier === value);
        if (selectedCam) {
            setChip(prevChip => ({
                ...prevChip,
                camIdentifier: selectedCam.identifier,
                slotCamId: selectedCam.slotCamId
            }));
            console.log("HERE", selectedCam.slotCamId);
        }
    } else {
      setChip(prevCam => ({ ...prevCam, [name]: inputValue }));
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (chip.id && chip.id.trim() !== '') {

        // UPDATE genérico: solo los campos whitelisteados por el backend
        await updateStockChip(chip.id, {
          associatedName: chip.associatedName,
          brand: chip.brand,
          phoneNumber: chip.phoneNumber,
          serialNumber: chip.serialNumber,
          status: chip.status,
        });

        // si el chip no tenía cámara asignada y ahora se eligió una, el server
        // asigna camIdentifier/customerId y setea assignedDate
        if (!isAssigned && chip.customerId && chip.camIdentifier) {
          await assignStockChipCamara(chip.id, {
            camIdentifier: chip.camIdentifier,
            customerId: chip.customerId,
          });
        }
      } else {
        // CREATE
        const created = await createStockChip(chip);

        // el POST no setea assignedDate; si ya viene con cámara asignada,
        // se completa con el mismo endpoint que usa el flujo de UPDATE
        if (created?.id && chip.customerId && chip.camIdentifier) {
          await assignStockChipCamara(created.id, {
            camIdentifier: chip.camIdentifier,
            customerId: chip.customerId,
          });
        }
      }

      //actualiza el camara slot
      const filteredData = {
        "chipICCID":chip.serialNumber,
      }
      await updateCamaraById(chip.slotCamId, filteredData);

      toast.success(`Chip ${chip.id ? 'editado' : 'creado'} exitosamente`, {
        position: 'top-right',
        autoClose: 3000,
      });
      setLoading(false);
      onClose();
    } catch (error) {
      if (notifySlotQuotaError(error, toast)) {
        setLoading(false);
        return;
      }
      if(error instanceof Error) {
        if (error.message === "Request failed with status code 409") {
          toast.error('El chip ya existe', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        } else {
          console.error('Error al guardar el chip:', error);
          toast.error('Error al guardar el chip.', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } else {
          console.error("Error:", error);
        }
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start pt-12 z-50 overflow-y-auto">
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-2xl my-8 mx-4">
        
        <div className="flex justify-between items-center border-b pb-4 mb-4">
          <h2 className="text-xl font-bold">{chipData ? 'Editar Chip' : 'Añadir Nuevo Chip'}</h2>
          <button className="text-gray-500 hover:text-gray-700 text-2xl" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          
        {/* Marca */}
          <div className="mb-4">
            <label htmlFor="brand" className="block text-gray-700 font-medium mb-1 after:content-['*'] after:text-red-500">Compañía</label>
            <input
              type="text"
              id="brand"
              name="brand"
              value={chip.brand}
              onChange={handleInputChange}
              required
              className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

        {/* nombre asociado */}
          <div className="mb-4">
            <label htmlFor="associatedName" className="block text-gray-700 font-medium mb-1 after:content-['*'] after:text-red-500">Nombre Asociado</label>
            <input
              type="text"
              id="associatedName"
              name="associatedName"
              value={chip.associatedName}
              onChange={handleInputChange}
              required
              className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        
          
          
          <div className="mb-4">
            <label htmlFor="serialNumber" className="block text-gray-700 font-medium mb-1 after:content-['*'] after:text-red-500">ICCID</label>
            <input
              type="text"
              id="serialNumber"
              name="serialNumber"
              value={chip.serialNumber}
              onChange={handleInputChange}
              className={`w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 
                  ${isAssigned ? "bg-gray-100 cursor-not-allowed" : ""}`}
              required 
              readOnly={isAssigned}  
            />
          </div>

          
          <div className="mb-4">
            <label htmlFor="phoneNumber" className="block text-gray-700 font-medium mb-1 after:content-['*'] after:text-red-500">Teléfono/ MSISDN (ej. 54912345678)</label>
            <input
              type="text"
              id="phoneNumber"
              name="phoneNumber"
              value={chip.phoneNumber}
              onChange={handleInputChange}
              required
              className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="mb-4">
            <label htmlFor="status" className="block text-gray-700 font-medium mb-1 after:content-['*'] after:text-red-500">Estado</label>
            <select
              id="status"
              name="status"
              value={chip.status}
              onChange={handleInputChange}
              required
              className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Seleccione un estado</option>
              <option value="Activo">Activo</option>
              <option value="Desactivado">Desactivado</option>
              <option value="Retirado">Retirado</option>
              <option value="Test">Test</option>
            </select>
          </div>


              {/* Cliente */}
            <div className="mb-4">
              <label htmlFor="customerId" className="block text-gray-700 font-medium mb-1">Cliente *</label>
              {loadingCustomers ? (
                <p>Cargando clientes...</p>
              ) : (
                <select 
                  id="customerId" 
                  name="customerId" 
                  value={chip.customerId} 
                  onChange={handleInputChange} 
                  className={`w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 
                    ${isAssigned ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  required
                  disabled={isAssigned}
                >
                  <option value="" disabled>Seleccione un cliente</option>
                  {customers.map((c) => (
                    <option key={c.id} value={c.customerId}>
                      {c.name || c.customerId}
                    </option>
                  ))}
                </select>
              )}
            </div>

          
          {/* Cámara por cliente */}
            <div className="mb-4">
              <label htmlFor="camIdentifier" className="block text-gray-700 font-medium mb-1">Identificador de la Cámara *</label>
              {isAssigned ? (
                <input
                  type="text"
                  id="camIdentifier"
                  name="camIdentifier"
                  value={chip.camIdentifier}
                  readOnly
                  className="w-full p-2 border rounded-md bg-gray-100 cursor-not-allowed"
                />
              ) : loadingCams ? (
                <p>Cargando cámaras...</p>
              ) : (
                <select 
                  id="camIdentifier" 
                  name="camIdentifier" 
                  value={chip.camIdentifier} 
                  onChange={handleInputChange} 
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
                  required
                  disabled={!chip.customerId}
                >
                  <option value="">Seleccione una cámara</option>
                  {camsByCustomer.map((c) => (
                    <option key={c.identifier} value={c.identifier}>{c.identifier}</option>
                  ))}
                </select>
              )}
            </div>


          <div className="mb-4">
            <label htmlFor="assignedDate" className="block text-gray-700 font-medium mb-1">Fecha Asignada</label>
            <input
              type="text"
              id="assignedDate"
              name="assignedDate"
              value={chip.assignedDate ? new Date(chip.assignedDate).toLocaleDateString('es-ES'): ""}
              readOnly
              className="w-full p-2 border rounded-md bg-gray-100 cursor-not-allowed"
            />
          </div>

          <div className="mb-4">
            <label htmlFor="assignedDate" className="block text-gray-700 font-medium mb-1">Fecha Creación</label>
            <input
              type="text"
              id="assignedDate"
              name="assignedDate"
              value={chip.createdAt ? new Date(chip.createdAt).toLocaleDateString('es-ES'): ""}
              readOnly
              className="w-full p-2 border rounded-md bg-gray-100 cursor-not-allowed"
            />
          </div>

          {/* Datos de sincronización CSV (solo lectura) */}
          <div className="mb-4 grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="imsi" className="block text-gray-700 font-medium mb-1">IMSI</label>
              <input
                type="text"
                id="imsi"
                name="imsi"
                value={chip.imsi ?? ''}
                readOnly
                className="w-full p-2 border rounded-md bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label htmlFor="plan" className="block text-gray-700 font-medium mb-1">Plan</label>
              <input
                type="text"
                id="plan"
                name="plan"
                value={chip.plan ?? ''}
                readOnly
                className="w-full p-2 border rounded-md bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label htmlFor="tecnologia" className="block text-gray-700 font-medium mb-1">Tecnología</label>
              <input
                type="text"
                id="tecnologia"
                name="tecnologia"
                value={chip.tecnologia ?? ''}
                readOnly
                className="w-full p-2 border rounded-md bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label htmlFor="consumo" className="block text-gray-700 font-medium mb-1">Consumo</label>
              <input
                type="text"
                id="consumo"
                name="consumo"
                value={chip.consumo ?? ''}
                readOnly
                className="w-full p-2 border rounded-md bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label htmlFor="etiquetas" className="block text-gray-700 font-medium mb-1">Etiquetas</label>
              <input
                type="text"
                id="etiquetas"
                name="etiquetas"
                value={chip.etiquetas ?? ''}
                readOnly
                className="w-full p-2 border rounded-md bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label htmlFor="notasDeLinea" className="block text-gray-700 font-medium mb-1">Notas de Línea</label>
              <input
                type="text"
                id="notasDeLinea"
                name="notasDeLinea"
                value={chip.notasDeLinea ?? ''}
                readOnly
                className="w-full p-2 border rounded-md bg-gray-100 cursor-not-allowed"
              />
            </div>
          </div>

          <hr className="my-6 border-gray-200" />

          <div className="flex justify-end gap-2">
            <button type="button" className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600" onClick={onClose}>
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-blue-300"
            >
              {loading ? 'Guardando...' : 'Guardar'}
            </button>
          </div>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default SaveAndEditChipModal;
